import { s3PublicUrl } from './s3PublicUrl';
import { readStoredUserData } from './gameStages';
import { computePuzzleGrid } from './puzzleGrid';

export { computePuzzleGrid } from './puzzleGrid';

function parseImgArray(raw) {
  if (Array.isArray(raw)) {
    return raw.map((item) => s3PublicUrl(item)).filter(Boolean);
  }
  if (typeof raw === 'string' && raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => s3PublicUrl(item)).filter(Boolean);
      }
    } catch {
      /* ignore */
    }
  }
  return [];
}

const DEFAULT_ASSIGNMENT_STAGE_COUNT = 3;

/** Reveal (completed / total assigned) × 100 based on filled assignment slots. */
export function getPuzzleRevealPercent(completedAssignmentDays, totalAssignedStages) {
  const done = Number(completedAssignmentDays);
  const total = Number(totalAssignedStages);
  const stageCount =
    Number.isFinite(total) && total > 0 ? total : DEFAULT_ASSIGNMENT_STAGE_COUNT;

  if (!Number.isFinite(done) || done <= 0) return 0;
  if (done >= stageCount) return 100;
  return (done / stageCount) * 100;
}

export function getPuzzleThemeConfig(themeData, puzzleIdOverride) {
  const stored = readStoredUserData();
  const puzzleId = puzzleIdOverride ?? stored.puzzle_id ?? stored.puzzleid ?? null;
  const slices = parseImgArray(themeData?.img_array);
  const image = s3PublicUrl(themeData?.puzzle_image) || slices[0] || '';

  const sliceCount = slices.length;
  const totalPuzzles = Math.floor(Number(themeData?.total_puzzles));
  const legacyParts = Math.floor(Number(themeData?.puzzle_parts));
  let parts = Math.floor(Number(themeData?.total_puzzles ?? themeData?.puzzle_parts));
  if (sliceCount >= 2 && sliceCount <= 100) {
    if (totalPuzzles === sliceCount || legacyParts === sliceCount) {
      parts = totalPuzzles === sliceCount ? totalPuzzles : legacyParts;
    } else {
      parts = sliceCount;
    }
  }
  const savedRows = Math.floor(Number(themeData?.row));
  const savedCols = Math.floor(Number(themeData?.col));
  let numRows = 3;
  let numCols = 3;
  if (
    Number.isFinite(parts) &&
    parts >= 2 &&
    parts <= 100 &&
    Number.isFinite(savedRows) &&
    Number.isFinite(savedCols) &&
    savedRows * savedCols === parts
  ) {
    numRows = savedRows;
    numCols = savedCols;
  } else if (Number.isFinite(parts) && parts >= 2 && parts <= 100) {
    const grid = computePuzzleGrid(parts);
    numRows = grid.rows;
    numCols = grid.cols;
  } else {
    numRows = Math.max(2, Math.min(10, savedRows || 3));
    numCols = Math.max(2, Math.min(10, savedCols || 3));
  }
  const title =
    String(themeData?.landing_page_title4 ?? themeData?.landing_title ?? 'Big Picture').trim() ||
    'Big Picture';

  return {
    image,
    images: slices,
    slices,
    puzzleId,
    numRows,
    numCols,
    title,
    titleColor: themeData?.landing_page_title_color ?? themeData?.text_color ?? null,
    buttonBg: themeData?.landing_page_button_bgcolor ?? themeData?.box_bg_color ?? null,
    accentColor: themeData?.button_color ?? themeData?.box_bg_color ?? null,
  };
}
